const ENDPOINT =
  "https://us-central1-team-edelstein.cloudfunctions.net/api/submit-oh-feedback";

/**
 * Submit feedback from the public form. No auth — relies on the magic-token URL.
 * @returns {Promise<{ok: boolean, alreadySubmitted?: boolean, error?: string}>}
 */
export async function submitPublicFeedback({ id, token, feedback }) {
  try {
    const res = await fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, token, feedback }),
    });
    if (res.ok) {
      const data = await res.json().catch(() => ({}));
      return { ok: true, ...data };
    }
    let errorText = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      errorText = data.error || errorText;
    } catch { /* ignore */ }
    return { ok: false, error: errorText };
  } catch (err) {
    return { ok: false, error: err?.message || "Network error" };
  }
}
